import { api } from 'app/config/apiConfig';
import { Pagination } from 'app/types/common';
import { WaitingListEntry } from '../model/types';
import { UnitType } from 'entities/Contract';

interface Params {
  page?: number;
  limit?: number;
  orderBy?: string;
  isCompleted?: boolean;
  warehouseId?: string;
  search?: string;
  preferredDateFrom?: string;
  preferredDateTo?: string;
  unitType?: UnitType;
  squareFrom?: number;
  squareTo?: number;
}

export const getPaginatedWaitingListEntriesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPaginatedWaitingListEntries: build.query<Pagination<WaitingListEntry>, Params | void>({
      query: (args) => ({
        url: '/waiting-list-entry',
        params: args ? { ...args } : undefined,
      }),
      providesTags: ['Waiting list'],
    }),
  }),
});

export const { useGetPaginatedWaitingListEntriesQuery } = getPaginatedWaitingListEntriesApi;
